<template>
  <div class="setting-main-container customization">
    <div class="card setting-card">
      <ul class="tabs">
        <li class="tab" v-for="(tap, index) in taps" :key="index" @click="setActiveTab(tap.tab_name)">
          <a :class="['tab-link', {'a-active': activeTab === tap.tab_name}]" href="#">
            {{ $t(tap.title) }}
          </a>
        </li>
      </ul>
      <!-- billing address Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'BILLINGADDRESS'" class="billingaddress-tab">
          <form action="" class="mt-3" @submit.prevent="updateBillingAddress">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.name') }}</label>
                        <base-input
                        v-model.trim="billing.name"
                        type="text"
                        name="address_name"
                        tab-index="7"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.state') }}</label>
                        <base-input
                        v-model="billing.state"
                        name="billing.state"
                        type="text"
                        tab-index="9"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.address') }}</label>
                        <base-text-area
                        v-model.trim="billing.address_street_1"
                        :tabindex="11"
                        :placeholder="$t('general.street_1')"
                        type="text"
                        name="billing_street1"
                        rows="2"
                        @input="$v.billing.address_street_1.$touch()"
                        />
                        <div v-if="$v.billing.address_street_1.$error">
                        <span v-if="!$v.billing.address_street_1.maxLength" class="text-danger">
                            {{ $t('validation.address_maxlength') }}
                        </span>
                        </div>
                        <base-text-area
                        :tabindex="12"
                        v-model.trim="billing.address_street_2"
                        :placeholder="$t('general.street_2')"
                        type="text"
                        name="billing_street2"
                        rows="2"
                        @input="$v.billing.address_street_2.$touch()"
                        />
                        <div v-if="$v.billing.address_street_2.$error">
                        <span v-if="!$v.billing.address_street_2.maxLength" class="text-danger">
                            {{ $t('validation.address_maxlength') }}
                        </span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.country') }}</label>
                        <base-select
                        v-model="billing_country"
                        :options="billingCountries"
                        :searchable="true"
                        :show-labels="false"
                        :allow-empty="true"
                        :tabindex="8"
                        :placeholder="$t('general.select_country')"
                        label="name"
                        track-by="id"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.city') }}</label>
                        <base-input
                        v-model="billing.city"
                        name="billing.city"
                        type="text"
                        tab-index="10"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.phone') }}</label>
                        <base-input
                        v-model.trim="billing.phone"
                        type="text"
                        name="phone"
                        tab-index="13"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.zip_code') }}</label>
                        <base-input
                        v-model.trim="billing.zip"
                        type="text"
                        name="zip"
                        tab-index="14"
                        />
                    </div>
                </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>
        </div>
      </transition>
      <!-- shipping address Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'SHIPPINGADDRESS'" class="shippping-tab">
          <form action="" class="mt-3" @submit.prevent="updateShippingAddress">
            <div class="row">
            
                <div class="col-sm-6">
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.name') }}</label>
                        <base-input
                        v-model.trim="shipping.name"
                        type="text"
                        name="address_name"
                        tab-index="15"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.state') }}</label>
                        <base-input
                        v-model="shipping.state"
                        name="shipping.state"
                        type="text"
                        tab-index="17"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.address') }}</label>
                        <base-text-area
                        v-model.trim="shipping.address_street_1"
                        :tabindex="19"
                        :placeholder="$t('general.street_1')"
                        type="text"
                        name="street_1"
                        rows="2"
                        @input="$v.shipping.address_street_1.$touch()"
                        />
                        <div v-if="$v.shipping.address_street_1.$error">
                        <span v-if="!$v.shipping.address_street_1.maxLength" class="text-danger">{{ $t('validation.address_maxlength') }}</span>
                        </div>
                        <base-text-area
                        v-model.trim="shipping.address_street_2"
                        :tabindex="20"
                        :placeholder="$t('general.street_2')"
                        type="text"
                        name="street_2"
                        rows="2"
                        @input="$v.shipping.address_street_2.$touch()"
                        />
                        <div v-if="$v.shipping.address_street_2.$error">
                        <span v-if="!$v.shipping.address_street_2.maxLength" class="text-danger">{{ $t('validation.address_maxlength') }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.country') }}</label>
                        <base-select
                        v-model="shipping_country"
                        :options="shippingCountries"
                        :searchable="true"
                        :show-labels="false"
                        :tabindex="16"
                        :allow-empty="true"
                        :placeholder="$t('general.select_country')"
                        label="name"
                        track-by="id"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.city') }}</label>
                        <base-input
                        v-model="shipping.city"
                        name="shipping.city"
                        type="text"
                        tab-index="18"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.phone') }}</label>
                        <base-input
                        v-model.trim="shipping.phone"
                        type="text"
                        name="phone"
                        tab-index="21"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{ $t('accounts.zip_code') }}</label>
                        <base-input
                        v-model.trim="shipping.zip"
                        type="text"
                        name="zip"
                        tab-index="22"
                        />
                    </div>
                </div>
            </div>
            
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, maxLength, alpha } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        activeTab: '',
        activeTab: "BILLINGADDRESS",
        taps:[
            {
            tab_name: 'BILLINGADDRESS',
            title: 'settings.addresses.billing_address',
            },
            {
                tab_name: 'SHIPPINGADDRESS',
                title: 'settings.addresses.shipping_address',
            },
        ],
        billing: {
            name: null,
            country_id: null,
            state: null,
            city: null,
            phone: null,
            zip: null,
            address_street_1: null,
            address_street_2: null,
            type: 'billing'
        },
        shipping: {
            name: null,
            country_id: null,
            state: null,
            city: null,
            phone: null,
            zip: null,
            address_street_1: null,
            address_street_2: null,
            type: 'shipping'
        },
        billingCountries: [],
        shippingCountries: [],
        billing_country: null,
        shipping_country: null
    }
  },
  computed: {
    hasBillingAdd () {
        let billing = this.billing
        if (
          billing.name ||
          billing.country_id ||
          billing.state ||
          billing.city ||
          billing.phone ||
          billing.zip ||
          billing.address_street_1 ||
          billing.address_street_2) {
          return true
        }
        return false
    },
    hasShippingAdd () {
        let shipping = this.shipping
        if (
          shipping.name ||
          shipping.country_id ||
          shipping.state ||
          shipping.city ||
          shipping.phone ||
          shipping.zip ||
          shipping.address_street_1 ||
          shipping.address_street_2) {
          return true
        }
        return false
    }
  },
  watch: {
    activeTab () {
      this.loadData()
    },
    billing_country (newCountry) {
        if (newCountry) {
          this.billing.country_id = newCountry.id
          this.isDisabledBillingState = false
        } else {
          this.billing.country_id = null
        }
      },
      shipping_country (newCountry) {
        if (newCountry) {
          this.shipping.country_id = newCountry.id
          return true
        } else {
          this.shipping.country_id = null
        }
      }
  },
  validations: {
      billing: {
        address_street_1: {
          maxLength: maxLength(255)
        },
        address_street_2: {
          maxLength: maxLength(255)
        }
      },
      shipping: {
        address_street_1: {
          maxLength: maxLength(255)
        },
        address_street_2: {
          maxLength: maxLength(255)
        }
      }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('companyInfo', [
      'loadData',
      'editCompany',
      'updateAddress'
    ]),
    async loadData () {
      let res = await window.axios.get('/api/settings/get-addresses')
      if (res.data.user.billing_address) {
          this.billing = res.data.user.billing_address
          if (res.data.user.billing_address.country_id) {
            this.billing_country = this.billingCountries.find((c) => c.id === res.data.user.billing_address.country_id)
          }
        }
        if (res.data.user.shipping_address) {
            this.shipping = res.data.user.shipping_address
            if (res.data.user.shipping_address.country_id) {
                this.shipping_country = this.shippingCountries.find((c) => c.id === res.data.user.shipping_address.country_id)
          }
        }

    },
    async fetchCountry () {
        let res = await window.axios.get('/api/countries')
        if (res) {
          this.billingCountries = res.data.countries
          this.shippingCountries = res.data.countries
        }
      },
    async updateBillingAddress () {
      this.$v.billing.$touch()

      if (this.$v.billing.$invalid) {
        return false
      }

      let data = {...this.billing}
      
      if (this.updateAddress(data)) {
        window.toastr['success'](this.$t('settings.addresses.updated_message'))
      }
    },
    async updateShippingAddress () {
      this.$v.shipping.$touch()

      if (this.$v.shipping.$invalid) {
        return false
      }

      let data = {...this.shipping}
      
      if (this.updateAddress(data)) {
        window.toastr['success'](this.$t('settings.addresses.updated_message'))
      }
    },
    setActiveTab (val) {
      this.activeTab = val
    }
  },
  mounted(){
    this.fetchCountry()
  }
}
</script>
<style>
  .fade-customize-enter-active {
    transition: opacity 0.9s;
  }

  .fade-customize-leave-active  {
    transition: opacity 0s;
  }

  .fade-customize-enter, .fade-customize-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
